import { GET_NOTES } from '../../constants/actions/policy';

export function getNotes(payload) {
    return {
        type: GET_NOTES,
        payload,
    };
}
